module.exports = ".addMargin {\n  padding: 20px;\n  line-height: 25px; }\n\n.help-icon-section {\n  text-align: end; }\n\n.help-icon-section .help-icon {\n    width: 100px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/error/error.component.scss
// module id = ./src/app/containers/error/error.component.scss
// module chunks = main